import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaResultPage } from './plaza-result';

@NgModule({
  declarations: [
    PlazaResultPage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaResultPage),
    TranslateModule.forChild()
  ],
})
export class PlazaResultPageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-result/plaza-result.module.ts